import './data-section-title.styl'

function DataSectionTitle(props) {
  return (
    <label className="data-section-title">
      {props.children}
    </label>
  )
}

export default DataSectionTitle
